import React from 'react';
import { UnitHeader } from './UnitHeader';

interface UnitPageHeaderProps {
  unitNameRef: React.RefObject<HTMLHeadingElement | null>;
}

export const UnitPageHeader: React.FC<UnitPageHeaderProps> = ({
  unitNameRef,
}) => {
  return <UnitHeader unitNameRef={unitNameRef} />;
};
